export const types = {
  set: 'SET_LOADING',
  unset: 'UNSET_LOADING'
} as const

export function setLoading() {
  return { type: types.set }
}
export function unsetLoading() {
  return { type: types.unset }
}
